<template>
  <div class="related">
    <div class="related__content">
      <router-link
        v-for="(item, n) in itemList"
        :to="{path: item.route}"
        :key="n"
        class="related-item">
        <div class="related-item__label">
          <h5 class="related-item__label__heading">{{item.label}}</h5>
        </div>
        <BaseHeading :size="3" color="white">{{item.text}}</BaseHeading>
        <div class="related-item__arrow">
          <SvgArrow/>
        </div>
      </router-link>
    </div>
  </div>
</template>
<script>
import SvgArrow from '@/components/SvgArrow/SvgArrow'
export default {
  name: 'SectionRelated',
  components: {
    SvgArrow
  },
  props: {
    itemList: Array
  }
}
</script>
<style lang="scss" scoped>
  @import './section-related'
</style>



// WEBPACK FOOTER //
// src/components/SectionRelated/SectionRelated.vue